import PathPicker, { PathPickerType } from '../../../../PathPicker';
import { getValueByNodes, removeAssocItem, uploadPackageItems, uploadAttachment } from '../../../actions/form';
import { getValue } from '../../../lib/associations';
import { Dispatch } from 'redux';
import { FieldJson } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { is } from 'ramda';
import Upload from '../../../../Upload';
import { getWorkflowFormData, getAttachmentFormData } from '../../../lib/upload';
import { fileAdded } from '../../../../Upload/utils/activityStreams';
const { Icon } = window.Material;

const getType = (type: 'file' | 'folder' | 'all' | undefined): PathPickerType => {
	let result;
	switch (type) {
		case 'file': {
			result = PathPickerType.FILE;
			break;
		}
		case 'folder': {
			result = PathPickerType.FOLDER;
			break;
		}
		case 'all': {
			result = PathPickerType.ALL;
			break;
		}
		default: {
			result = PathPickerType.FILE;
		}
	}
	return result;
};

export interface AssociationInterface extends FieldJson, ReduxComponentInterface {
	mandatory: boolean;
	disabled: boolean;
	className: string;
	title: string;
	formInstanceId: string;
	isModalOpen: boolean;
	onChange?: (...args: any[]) => void;
	innerFormInstanceId?: string;
	upload?: boolean;
	selfId?: string;
	readOnly: boolean;
	repoPath: string;
	validate?: (name: string, value: any) => void;
}

class Association extends window.React.PureComponent<AssociationInterface> {
	async componentDidMount() {
		const { actions, value, init, name, formInstanceId, innerFormInstanceId, validate, mandatory } = this.props;
		const valueArray = getValue(value);
		const initArray = init ? getValue(init) : [];
		const res = await actions.getValueByNodes(formInstanceId, name, valueArray.concat(initArray), innerFormInstanceId);
		if (mandatory && validate) {
			validate(name, res.value.response.data.items);
		}
	}

	onItemDelete = (nodeRef: string) => {
		const { actions, formInstanceId, innerFormInstanceId, name } = this.props;
		actions.removeAssocItem(formInstanceId, name, nodeRef, innerFormInstanceId);
	};

	onSubmit = async (nodeRefs: string[]) => {
		const { actions, formInstanceId, innerFormInstanceId, name, validate, mandatory } = this.props;
		const res = await actions.getValueByNodes(formInstanceId, name, nodeRefs, innerFormInstanceId);
		if (mandatory && validate) {
			validate(name, res.value.response.data.items);
		}
	};

	onUpload = async (file: any, onProgress: Function) => {
		const {
			actions,
			formInstanceId,
			innerFormInstanceId,
			control: { params },
			name,
		} = this.props;
		if (params._taskId) {
			await actions.uploadPackageItems(
				formInstanceId,
				getWorkflowFormData(params._taskId, file),
				name,
				innerFormInstanceId,
				onProgress
			);
		} else if (params.parentNodeRef) {
			await actions.uploadAttachment(
				formInstanceId,
				getAttachmentFormData(params.parentNodeRef, file),
				name,
				innerFormInstanceId,
				file.name,
				onProgress
			);
		} else {
			throw new Error('No upload action provided');
		}
	};

	render() {
		const {
			name,
			label,
			mandatory,
			disabled,
			value,
			error,
			formInstanceId,
			selfId,
			control: { params },
			readOnly,
		} = this.props;

		const enableUpload = params?._taskId || params.enableUpload;
		const type = getType(params?.type);
		return readOnly ? (
			<div className={`form-row row-${name} simple-row`}>
				<label>{label}</label>
				<div id={name}>
					{value?.length > 0 ? (
						Array.isArray(value) ? (
							value.map((it, index) => {
								return (
									<div key={index} className="edcMetaLink" id={it.nodeRef}>
										<a href={`${window.appContext}/page/document-details?nodeRef=${it.nodeRef}`} target="_blank">
											<Icon className="Icon fa fa-file-alt" fontSize="small" />
											{it.name}
										</a>
									</div>
								);
							})
						) : (
							<div dangerouslySetInnerHTML={{ __html: value }} />
						)
					) : (
						<div>{window.Alfresco.messages.global['label.none']}</div>
					)}
				</div>
			</div>
		) : (
			<div
				id={name}
				className={`assoc-row ${enableUpload ? 'form-row package-items' : 'form-row'} row-${name}${
					readOnly ? ' simple-row' : ''
				}`}
			>
				<label>
					{label}
					{mandatory ? '*' : ''}
				</label>
				<span className="error-title">{error}</span>
				<PathPicker
					isMandatory={mandatory}
					disabled={readOnly || disabled}
					type={type}
					showFileList
					multiSelect
					formInstanceId={formInstanceId}
					reducerPath={[formInstanceId, 'formModal']}
					selected={
						value ? (is(String, value) ? value.split(',') : value.map((item: any) => item.nodeRef || item)) : []
					}
					hidden={selfId ? [selfId] : []}
					onItemDelete={this.onItemDelete}
					onSubmit={this.onSubmit}
					name="assocModal"
					id={name}
				/>
				{enableUpload && !disabled && !readOnly && (
					<Upload
						multiple
						showButton
						name="packageItemsUpload"
						uploadAction={this.onUpload}
						disallowedExtensions={params.disallowedExtensions || []}
					/>
				)}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: window.redux.bindActionCreators(
		{ getValueByNodes, removeAssocItem, uploadPackageItems, uploadAttachment },
		dispatch
	),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(Association);
